import { render } from "./ChangeLog.vue?vue&type=template&id=68e0d7b3&ts=true"
import script from "./ChangeLog.vue?vue&type=script&lang=ts"
export * from "./ChangeLog.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__